import { Box, InputAdornment, Typography } from '@mui/material'
import AdxFullWindowTitleBar from 'components/reusable/fullWindowTitleBar/AdxFullWindowTitleBar'
import { useNavigate } from 'react-router-dom'
import useOpenClose from 'services/hooks/useOpenClose'
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import { useMutation } from 'react-query'
import { buyCreditPackage } from 'services/api/modules/recruitment/order'
import { Field, Form, Formik } from 'formik'
import {
  DEFAULT_TOP_UP_CREDIT,
  TopUpCreditValidation,
} from 'module/recruitment/utils/jobAdValidation'
import * as Yup from 'yup'
import AdxErrorMessage from 'components/custom/AdxErrorMessage'
import AdxInput from 'components/custom/AdxInput'
import SnackbarRecruitment from 'module/recruitment/reusable/SnackbarRecruitment'
import AdxButton from 'components/custom/AdxButton'

const TopUpCredit = ({ fees = 0 }) => {
  const navigate = useNavigate()

  const handleClose = () => {
    navigate('/app/recruitment')
  }
  const returnToPayment = () => {
    navigate(-1)
  }

  //      // State and Functions for Radio Buttons Component
  //   const [radioValue, setRadioValue] = useState('null')

  //   const handleChangeRadio = (event) => {
  //     setRadioValue(event.target.value)
  //   }

  //Cancel modal
  const cancelModal = useOpenClose(false)
  const errorSnackbar = useOpenClose(false)

  //modal component
  const CloseTopUpCancelModal = () => (
    <AdxInfoModal
      variant={'warning'}
      open={cancelModal.isOpen}
      onClose={cancelModal.handleClose}
      muiIcon="warning_icon"
      iconColor="warning.main"
      title="Confirm exit?"
      subtitle=""
      footerButtons
      firstBtnLabel={'Confirm'}
      firstBtnHandle={returnToPayment}
      secondBtnLabel={'Cancel'}
      secondBtnHandle={cancelModal.handleClose}
    ></AdxInfoModal>
  )

  // API CALL

  //   const {
  //     isLoading: creditPackageIsLoading,
  //     error: creditPackageError,
  //     data:creditPackageData,
  //   } = useQuery(
  //     ['getCreditPackage'],
  //   async () => {
  //     const { data } = await getCreditPackage();
  //     return data;
  //   },
  //   {
  //     refetchOnWindowFocus: false,
  //   }
  // );
  const {
    mutate: buyCredit,
    isSuccess: buyCreditIsSuccess,
    isLoading: buyCreditisLoading,
  } = useMutation((value) => buyCreditPackage(value), {
    onSuccess: (response) => {
      console.log(response)
      window.location.href = response.data.url
    },

    onError: (error) => {
      console.log(error)
      errorSnackbar.handleOpen()
    },
  })

  //   const handleTopUp=(e)=>{
  //     // buyCredit(JSON.stringify({credit_value:radioValue }))
  //     console.log(JSON.stringify(e))
  //   }

  // const PackageCard=({label,actualPrice,creditAmount,bestSeller=false})=>{
  //     return (
  //     <Box
  //         display="flex"
  //         alignItems="center"
  //         justifyContent="space-between"
  //         px={2}
  //         py={1}
  //         sx={{
  //             border:"1px solid",
  //             borderColor:"gray-line.main",
  //         }}
  //         >
  //             <Box
  //                 display="flex"
  //                 alignItems="center"
  //                 columnGap={1}
  //                 >
  //                     <Typography
  //                     variant="body2"
  //                     color="light-gray-text.main"
  //                     >(Pay RM {actualPrice}.00)
  //                 </Typography>

  //                 {bestSeller?
  //                 <Typography
  //                     variant="body2"
  //                         color="yellow-02.main"

  //                     >Bestseller
  //                 </Typography>:null}
  //             </Box>
  //             <Typography
  //                 variant="body1"
  //                 color="dark-text.main"
  //                 sx={{
  //                     fontWeight:"bold"
  //                 }}
  //                 > RM {creditAmount}.00 credits
  //             </Typography>
  //         </Box>)

  // }
  const onSubmit = (e) => {
    // console.log(JSON.stringify(e))
    buyCredit(e)
  }

  // if(creditPackageIsLoading){
  //     return (
  //         <Box
  //         bgcolor="gray-background.main"
  //         minHeight="100vh"
  //         >
  //             <AdxFullWindowTitleBar
  //                 onClose={handleClose}
  //                 >
  //                 Top Up Credit
  //             </AdxFullWindowTitleBar>
  //                 <Box
  //                 display="flex"
  //                 justifyContent="center"
  //             >
  //                 <Box
  //                 bgcolor="white.main"
  //                 width={700}
  //                 px={4}
  //                 maxHeight="100vh"
  //                 >
  //                      <Typography
  //                         variant="h3"
  //                         color="dark-text.main"
  //                         marginTop={4}
  //                         sx={{
  //                             fontWeight:"bold"
  //                         }}
  //                         >Choose top up amount
  //                     </Typography>
  //                         <Box
  //                         display="flex"
  //                         alignItems="center"
  //                         justifyContent="center"
  //                         width={1}
  //                         height={150}
  //                         >
  //                             <CircularProgress color="alternate"/>
  //                         </Box>
  //                     <Box
  //                     marginTop={6}
  //                     display="flex"
  //                     flexDirection="column"
  //                     alignItems="center"
  //                     >
  //                         <Box
  //                         display="flex"
  //                         columnGap={0.5}
  //                         marginBottom={1}
  //                         >
  //                             <Typography
  //                                     variant="body2"
  //                                     color="light-gray-text.main"
  //                                     >By clicking “Pay now”, you agree to our
  //                             </Typography>
  //                             <TermAndCondition/>
  //                         </Box>
  //                         <AdxButton
  //                         size="standard"
  //                         sx={{
  //                             width:500
  //                             }}
  //                         // onClick={handleTopUp}
  //                         >
  //                             Pay now
  //                         </AdxButton>
  //                         <AdxButton variant={'ghost'} size="standard"
  //                         sx={{
  //                             width:500,
  //                             marginTop:1,
  //                         }}
  //                         onClick={cancelModal.handleOpen}
  //                         >
  //                             Cancel
  //                         </AdxButton>
  //                     </Box>

  //                 </Box>

  //                 </Box>

  //         </Box>

  //     )
  // }
  // else{
  return (
    <Box bgcolor="gray-background.main" sx={{ height: '100%' }}>
      <AdxFullWindowTitleBar onClose={handleClose}>Topup Credit</AdxFullWindowTitleBar>
      <Box display="flex" justifyContent="center" px={4}>
        <Box bgcolor="white.main" width={700} px={12} minHeight="calc(100vh - 59px)">
          <Typography
            variant="h4"
            color="dark-text.main"
            my={4}
            sx={{
              fontWeight: 'bold',
            }}
          >
            How much do you want to topup?
          </Typography>
          <Formik
            enableReinitialize={true}
            validateOnBlur={false}
            initialValues={DEFAULT_TOP_UP_CREDIT}
            validationSchema={Yup.object().shape(TopUpCreditValidation)}
            onSubmit={onSubmit}
          >
            {({ values, touched, errors, handleSubmit, setFieldValue }) => {
              // const { job_advertisement_duration } = values;
              const handleValueChange = (value) => {
                setFieldValue('credit_value', value)
              }

              return (
                <Box
                  sx={{
                    width: '100%',
                  }}
                >
                  <Form>
                    <Box
                      display="flex"
                      alignItems="center"
                      justifyContent="space-between"
                      flexDirection="column"
                      gap={2}
                    >
                      <Field
                        as={AdxInput}
                        size="large"
                        name="credit_value"
                        value={values.credit_value}
                        placeholder="0.00"
                        startAdornment={
                          <InputAdornment position="start">
                            <Box>
                              <Typography>RM</Typography>
                            </Box>
                          </InputAdornment>
                        }
                        sx={{ flexGrow: 1 }}
                        type="number"
                        min="0"
                        isErrorShown={touched.credit_value && Boolean(errors.credit_value)}
                        errorMessage={<AdxErrorMessage>{errors.credit_value}</AdxErrorMessage>}
                      />
                    </Box>
                    {!touched.credit_value && (
                      <Typography variant="body2" color="light-gray-text.main">
                        Minimum amount is RM 10
                      </Typography>
                    )}

                    <Box
                      mt={2}
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      columnGap={4}
                    >
                      <Box
                        bgcolor="default-background.main"
                        px={2}
                        py={1}
                        width={1 / 3}
                        onClick={() => handleValueChange(20)}
                        sx={{ cursor: 'pointer' }}
                      >
                        <Typography variant="subtitle1" color="alternate.main" align="center">
                          RM 20
                        </Typography>
                      </Box>
                      <Box
                        bgcolor="default-background.main"
                        px={2}
                        py={1}
                        width={1 / 3}
                        onClick={() => handleValueChange(50)}
                        sx={{ cursor: 'pointer' }}
                      >
                        <Typography variant="subtitle1" color="alternate.main" align="center">
                          RM 50
                        </Typography>
                      </Box>
                      <Box
                        bgcolor="default-background.main"
                        px={2}
                        py={1}
                        width={1 / 3}
                        onClick={() => handleValueChange(100)}
                        sx={{ cursor: 'pointer' }}
                      >
                        <Typography variant="subtitle1" color="alternate.main" align="center">
                          RM 100
                        </Typography>
                      </Box>
                    </Box>
                    <Box marginTop={8} display="flex" justifyContent="space-between" px={2}>
                      <Typography variant="body1" color="light-gray-text.main">
                        Topup amount
                      </Typography>
                      <Typography variant="body1" color="light-gray-text.main">
                        {' '}
                        RM {values.credit_value === '' ? 0 : values.credit_value}.00
                      </Typography>
                    </Box>
                    <Box
                      marginTop={2}
                      display="flex"
                      justifyContent="space-between"
                      px={2}
                      py={2}
                      sx={{
                        borderBottom: '1px solid',
                        borderBottomColor: 'gray-line.main',
                      }}
                    >
                      <Typography variant="body1" color="light-gray-text.main">
                        Fees
                      </Typography>
                      <Typography variant="body1" color="light-gray-text.main">
                        {' '}
                        RM {fees ?? 0}.00
                      </Typography>
                    </Box>
                    <Box marginTop={2} display="flex" justifyContent="space-between" px={2}>
                      <Typography variant="subtitle1" color="dark-text.main" fontWeight="bold">
                        Amount to pay
                      </Typography>
                      <Typography variant="subtitle1" color="dark-text.main" fontWeight="bold">
                        {' '}
                        RM {values.credit_value === '' ? 0 : values.credit_value + fees}.00
                      </Typography>
                    </Box>
                    <Box marginTop={6} display="flex" flexDirection="column" alignItems="center">
                      <Box display="flex" columnGap={0.5} marginBottom={1}>
                        <Typography variant="body2" color="light-gray-text.main">
                          By proceeding, you agree to our
                        </Typography>
                        {/* <TermAndCondition/> */}
                        <Typography
                          onClick={() =>
                            window.open(
                              'https://adnexio-hr-prod.s3.ap-southeast-1.amazonaws.com/terms_and_conditions/topup_service/topup_tnc_20230223.pdf',
                              '_blank'
                            )
                          }
                          variant="body2"
                          color="alternate.main"
                          sx={{
                            textDecoration: 'underline',
                            cursor: 'pointer',
                          }}
                        >
                          {' '}
                          Terms and Conditions
                        </Typography>
                        <Typography variant="body2" color="light-gray-text.main">
                          and
                        </Typography>
                        <Typography
                          variant="body2"
                          color="alternate.main"
                          sx={{
                            textDecoration: 'underline',
                            cursor: 'pointer',
                          }}
                          onClick={() =>
                            window.open('https://adnexio.jobs/privacy-policy', '_blank')
                          }
                        >
                          Privacy Policy
                        </Typography>
                      </Box>
                      {buyCreditisLoading ? (
                        <AdxButton
                          variant={'contained'}
                          isLoading
                          size="standard"
                          sx={{
                            width: 500,
                          }}
                        ></AdxButton>
                      ) : (
                        <AdxButton
                          variant={'contained'}
                          size="standard"
                          sx={{
                            width: 500,
                          }}
                          // onClick={()=>{handleTopUp(values)}}
                          onClick={() => {
                            handleSubmit()
                          }}
                        >
                          Pay now
                        </AdxButton>
                      )}

                      <AdxButton
                        variant={'ghost'}
                        size="standard"
                        sx={{
                          width: 500,
                          marginTop: 1,
                        }}
                        onClick={cancelModal.handleOpen}
                      >
                        Cancel
                      </AdxButton>
                      {cancelModal.isOpen ? <CloseTopUpCancelModal /> : null}
                    </Box>
                  </Form>
                </Box>
              )
            }}
          </Formik>
        </Box>
      </Box>
      {errorSnackbar.isOpen ? (
        <SnackbarRecruitment
          autoHideDuration={4000}
          status="error"
          TransitionComponent="slide"
          message="An error has occured. Please try again"
          open={errorSnackbar.isOpen}
          handleClose={errorSnackbar.handleClose}
        />
      ) : null}
      {/* <Box
                bgcolor="white.main"
                width={700}
                px={4}
                maxHeight="100vh"
                >
                     <Typography
                        variant="h3"
                        color="dark-text.main"
                        marginTop={4}
                        sx={{
                            fontWeight:"bold"
                        }}
                        >Choose top up amount
                    </Typography>
                    <FormControl>
                        <RadioGroup  value={radioValue} onChange={handleChangeRadio}>
                            <Box
                            marginTop={4}
                            display="flex"
                            flexDirection="column"
                            rowGap={2}
                            width={650}
                            
                            >
                                 {creditPackageData?.map((list) => {
                                    if (list.credit_value === 150) {
                                        return (
                                        <PackageCard
                                            key={list}
                                            label="Starter"
                                            actualPrice={list.credit_value}
                                            creditAmount={list.credit_received}
                                        />
                                        );
                                    } else if (list.credit_value === 250) {
                                        return (
                                        <PackageCard
                                            key={list}
                                            label="Standard"
                                            actualPrice={list.credit_value}
                                            creditAmount={list.credit_received}
                                            bestSeller={true}
                                        />
                                        );
                                    } else if (list.credit_value === 500) {
                                        return (
                                        <PackageCard
                                            key={list}
                                            label="Big Bundle"
                                            actualPrice={list.credit_value}
                                            creditAmount={list.credit_received}
                                        />
                                        );
                                    }
                                    })}
                               
                               
                            </Box>
                        </RadioGroup>
                    </FormControl>

                    <Box
                    marginTop={6}
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    >
                        <Box
                        display="flex"
                        columnGap={0.5}
                        marginBottom={1}
                        >
                            <Typography
                                    variant="body2"
                                    color="light-gray-text.main"
                                    >By clicking “Pay now”, you agree to our 
                            </Typography>
                            <TermAndCondition/>
                        </Box>
                       { buyCreditisLoading?
                       <AdxButton 
                       isLoading
                        size="standard" 
                        sx={{
                            width:500
                            }}
                        >
                            Top up Now
                        </AdxButton>
                        :
                        <AdxButton 
                        size="standard" 
                        sx={{
                            width:500
                            }}
                        onClick={handleTopUp}
                        >
                            Top up
                        </AdxButton>
                        }
                        
                        <AdxButton variant={'ghost'} size="standard" 
                        sx={{
                            width:500,
                            marginTop:1,
                        }} 
                        onClick={cancelModal.handleOpen}
                        >
                            Cancel
                        </AdxButton>
                        {cancelModal.isOpen ? <CloseTopUpCancelModal /> : null}
                    </Box>

                </Box>
            </Box> */}
    </Box>
  )
}
// }
export default TopUpCredit
